/**
 * 运营管理 - 简体中文
 */
export default {
  title: '运营管理',
  supervisorManage: '督学管理',
  supervisorCheck: '督学检查',
  supervisorData: '督学数据',
  supervisorEvaluationScore: '督学评价得分',
  // 督学管理页
  supervisorRoom: '松鼠AI督学室',
  dataUpdateTime: '数据更新时间',
  studentData: '学员数据',
  monthActive: '月活跃',
  vsLastMonth: '较上月',
  supervisorCount: '督学',
  activeCount: '活跃',
  people: '人',
  serviceRetention: '服务留存率',
  serviceCenterAllStudents: '服务中心所有学员',
  serviceRetentionTip: '3月服务留存率：3个月前该服务中心督学（督学状态是仅线上或自习室）的学生，本月还有多少比例的学生仍在此服务中心督学且月学习时长≥4小时。6月、9月、12月服务留存率同理，只是时间跨度分别延长到6个月前、9个月前和12个月前。',
  accountManage: '账户管理',
  quickIdentity: '自定义快捷身份',
  assignPermission: '分配权限',
  employeeAccount: '员工账号',
  addEmployee: '添加员工',
  schoolDataBase: '资料库',
  autoOrderConfig: '自动下单配置',
  supervisorEvaluation: '督学师考评',
  // 督学师考评
  abilityEval: '能力考评',
  toEval: '待考评',
  evaluated: '已考评',
  evalCount: '考评次数',
  firstTime: '首次',
  secondTime: '第二次',
  listenRecord: '听录音',
  score: '评分',
  lastScoreDetail: '上次评分情况',
  playRecord: '播放录音',
  evalScore: '考核评分',
  writeComment: '写评语:',
  optionalComment: '(非必填)',
  scoreDetail: '评分情况',
  difficultyExplain: '难度升降级讲解:',
  comment: '评语:',
  placeholderCampusIdEval: '请输入经销商Id',
  scoreUnit: '分',
  // 账户设置 AccountSet / AuthorityDetails
  employeeName: '员工姓名：',
  shortcutConfigPermission: '快捷配置权限',
  selectRoleTip: '请选择子账号身份，系统将自动快速配置子账号所需的权限',
  configThenAdjust: '（配置后，也可手动调整）',
  pagePermissionConfig: '页面权限配置',
  pagePermissionTip: '决定员工可以看到哪些页面',
  functionPermissionConfig: '功能权限配置',
  functionPermissionTip: '决定员工可以看到哪些功能',
  quickSearchAddPermission: '快捷搜索添加权限',
  dataPermissionConfig: '数据权限配置',
  dataPermissionTip: '决定员工可以看到哪些数据',
  pleaseConfigRole: '请配置角色',
  saveSuccess: '保存成功',
  saveFailed: '保存失败',
  // 账户设置 AccountSet 表格与消息
  createTimeCol: '创建时间',
  nameCol: '姓名',
  usernameCol: '用户名',
  phoneCol: '手机号',
  agentNo: '话务坐席号',
  disNo: '外呼显示手机号',
  accountStatus: '账户状态',
  remarkCol: '备注',
  employeeRole: '员工角色',
  customRole: '自定义角色',
  unbound: '未绑定',
  verifySuccess: '验证成功！',
  bindMobileSuccess: '绑定手机号成功！',
  editAccountFailed: '编辑账号失败！',
  // 安全验证/绑定手机号弹窗
  securityVerify: '安全验证',
  securityTip: '为了保证账户安全，请先输入密码',
  loginPassword: '登录密码：',
  placeholderLoginPassword: '请输入登录密码',
  bindMobile: '绑定手机号',
  enterLoginPassword: '请输入登录密码',
  placeholderBindMobile: '请输入绑定的手机号',
  getCode: '获取验证码',
  resendAfter: '{n}s后重新发送',
  codeCol: '验证码：',
  placeholderCode: '请输入验证码',
  enterBindMobile: '请输入绑定的手机号',
  invalidPhone: '输入手机号格式不正确',
  enterCode: '请输入验证码',
  // 员工账号 EmployeesAccount
  resignRecord: '离职记录',
  view: '查看',
  edit: '编辑',
  disable: '禁用',
  enable: '启用',
  wake: '唤醒',
  resign: '离职',
  more: '更多',
  reInvite: '重新邀请',
  cancelInvite: '取消邀请',
  reActivate: '重新激活',
  resetPassword: '重置密码',
  editRecord: '修改记录',
  confirmResetPwdTitle: '是否重置账户',
  confirmResetPwdDesc: '的登录密码',
  resetPwdInitial: '重置后，密码为初始密码【songguo123】',
  accountEditRecord: '账号修改记录',
  disableConfirmContent: '账号禁用操作提交后，{username}的{phone}关联账号将无法使用该账号访问{systemName}，请确认是否继续该操作？',
  resignConfirmContent: '账号离职操作提交后，{name}的{phone}关联账号相关数据将被清空，同时其钉钉组织将被移除，离职操作提交后将无法撤回，请确认是否继续该操作？',
  wakeConfirmContent: '账号唤醒操作提交后，{username}的{phone}关联账号可正常访问{systemName}，并加入当前的{campusId}钉钉部门，请确认是否继续该操作？',
  potentialCustomer: '潜在客户',
  supervisorStudent: '督学学员',
  accountStatusCol: '账号状态',
  accountRoleCol: '账号角色',
  updateTimeCol: '修改时间',
  enableSuccess: '启用成功',
  enableFailed: '启用失败',
  wakeSuccess: '唤醒成功',
  wakeFailed: '唤醒失败',
  resignSuccess: '离职成功',
  resignFailed: '离职失败',
  editAccountSuccess: '编辑账号成功',
  addAccountSuccess: '新增账号成功',
  addAccountFailed: '新增账号失败',
  resetPwdSuccess: '账户密码已重置为songguo123',
  reInviteSuccess: '已重新邀请，请提醒员工前往钉钉查收',
  copySuccess: '复制成功',
  handover: '交接',
  release: '释放',
  accountSearchLabel: '账号搜索:',
  namePlaceholder: '姓名',
  searchNameLabel: '姓名:',
  accountStatusLabel: '账号状态:',
  statusAll: '全部',
  statusNormal: '正常',
  statusDisabled: '禁用',
  statusPendingConfirm: '待确认',
  statusInfoMissing: '信息缺失',
  statusFrozen: '冻结',
  agentNoPlaceholder: '话务坐席号',
  disNoLabel: '外呼显示手机号:',
  disNoPlaceholder: '外呼显示手机号',
  leaveDateLabel: '离职日期',
  leaveTimeCol: '离职时间',
  opUserCol: '操作人',
  handoverRecordTitle: '交接记录',
  handoverUserCol: '交接人',
  assetCol: '资产',
  detailCol: '详情',
  dateRangeTo: '至',
  editRole: '编辑角色',
  deleteRole: '删除角色',
  confirmDeleteCustomRole: '确认要删除该自定义身份吗？',
  deleteSuccess: '删除成功',
  deleteFailed: '删除失败',
  editAccount: '编辑账户',
  addAccount: '新增账户',
  nameLabel: '姓名',
  realNameLabel: '真实姓名：',
  previewPermission: '预览权限',
  fillBasicInfo: '请填写基础信息',
  employeePhoneModifyTip: '注意:如需修改员工手机号，请在开通账号后由员工登录账号前往账号安全中心修改',
  selectRolePermission: '选择角色权限',
  placeholderRealName: '请输入真实姓名',
  phoneLabel: '手机号：',
  placeholderPhoneForRecovery: '请输入账号手机号，可用于找回密码',
  ruleEnterName: '请输入姓名',
  ruleEnterPhoneForRecovery: '请输入账号手机号，可用于找回密码',
  ruleInvalidPhone: '请输入正确的手机号',
  editFailed: '编辑失败',
  deleteCustomRoleTip: '删除后将不会影响之前使用该自定义身份配置权限的员工。',
  // 督学数据 SupervisorData tabs
  evaluationScoreTab: '评价分',
  supervisorProcess: '督学过程',
  supervisorResult: '督学结果',
  newStudentManage: '新手管理',
  supervisorGrowthTab: '督学师成长',
  // 督学管理 SupervisorManage
  provinceAvg: '省平均',
  scoreRate: '提分率',
  viewAll: '查看全部＞',
  validScoreCollectRate: '有效成绩收集率',
  examScoreRate: '大考提分率',
  newSupervisorNumTitle: '新增督学学员数',
  newSupervisorNumTxt: '本月新标记督学状态是自习室或仅线上的学员数',
  noSupervisorNumTitle: '未督学学员数',
  noSupervisorNumTxt: '未督学：未标记督学状态，或督学状态是督学到期，不督学',
  noSupervisorActiveNumTitle: '未督学活跃学员数',
  month3: '3个月',
  month6: '6个月',
  month9: '9个月',
  month12: '12个月',

  // SupervisorAgentData 督学代理商数据
  supervisorAgentDealerLabel: '请输入需要查看的经销商:',
  placeholderSupervisorAgentDealerId: '请输入经销商ID',
  supervisorAgentDealerIdCol: '经销商ID',
  supervisorAgentDealerNameCol: '经销商名称',
  cityNameCol: '城市',
  areaNameCol: '区域',
  supervisorOverviewCol: '督学管理总览',
  supervisorDataCol: '督学师数据',

  // SupervisorCheck 督学检查
  evalDealerLabel: '经销商',
  evalDealerIdCol: '经销商ID',
  belongCityCol: '所属市',
  evalDealerNameCol: '经销商名称',
  supervisorNameCol: '督学师姓名',
  contentCol: '内容',
  uploadRecordTimeCol: '上传录音时间',
  selfScoreCol: '自评分',
  managerScoreCol: '成绩',
  evaluatorCol: '考评人',
  evalTimeCol: '考评时间',
  assessTimeCol: '考核时间',

  // SupervisorManage 督学管理
  statsPeriodLabel: '统计周期',
  placeholderSelectMonth: '请选择月份',
  midtermExam: '期中考',
  finalExam: '期末考',
  yearLabel: '年份',
  subjectLabel: '学科',
  placeholderSelect: '请选择',
  yearSuffix: '年',
  // 指标说明
  scoreCollectRateTitle: '成绩收集率',
  scoreCollectRateText: '服务中心督学（自习室+仅线上）学生中，已收集到大考成绩的学生数占比',
  validScoreRateTitle: '有效成绩率',
  validScoreRateText: '当前大考成绩中有成绩证明的督学学生数占比',
  examScoreRateTitle: '大考提分率',
  examScoreRateText: '分子：本次大考分数比前一次大考分数高的督学学生数。 | 分母：提交了连续两次大考有效成绩的督学学生数',
  scoreManageTitle: '成绩管理',
  listGuidelineTitleColon: '：',
  dataUpdateTimeScoreManage: '数据更新时间：',
  emptyScoreManage: '暂无数据',
  collectResultNumLabel: '收集成绩数：',
  effectiveResultNumLabel: '有效成绩数：',
  supervisorStudentColon: '督学学生：',
  upResultNumLabel: '提分学生数：',
  twiceResultSupervisorColon: '提交两次成绩督学学生：',
  supervisorStatusLabel: '督学状态：',
  studyRoomCountLabel: '自习室（{n}）',
  onlineOnlyCountLabel: '仅线上（{n}）',
  scoreTimeRangeMidtermAutumn: '10~11月',
  scoreTimeRangeMidtermSpring: '4~5月',
  scoreTimeRangeFinalAutumn: '1~2月',
  scoreTimeRangeFinalSpring: '6~7月',
  scorePeriodLabel: '{year}{yearUnit}{range}',
  scorePeriodYearUnit: '年',

  // StudentDetails 学员详情
  studentDetailSubjectLabel: '学科',
  placeholderSelectSubject: '请选择学科',
  dateCol: '日期',
  learnTimeCol: '学习时长',
  subjectNameCol: '学科',
  questionMarkRateCol: '题目圈画情况',
  draftMarkRateCol: '草稿步骤书写率',
  draftPassRateCol: '草稿步骤合格率',
  questionTryCol: '例题试做留痕率',
  errorAnalyzeCol: '错因分析完成率',
  fillByCol: '填写人',
  viewSummary: '查看小结',

  // SupervisorData 共用表头
  studentNameCol: '学生姓名',
  writeRateCol: '督学小结填写率',
  summaryWriteRateCol: '小结填写率',
  teacherNameCol: '督学师姓名',
  questionTryRateCol: '例题试做留痕率',
  errorAnalyzeRateCol: '错因分析完成率',
  questionMarkValidRateCol: '读题圈画有效率',
  readQuestionMarkRateCol: '读题圈画覆盖率',
  threeMonthSurvivalRateCol: '3月服务留存率',
  sixMonthSurvivalRateCol: '6月服务留存率',
  nineMonthSurvivalRateCol: '9月服务留存率',
  twelveMonthSurvivalRateCol: '12月服务留存率',
  thisMonthHighActiveRateCol: '本月高活占比',
  lastMonthHighActiveRateCol: '上月高活占比',
  beforeLastMonthHighActiveRateCol: '上上月高活占比',
  supervisorLabel: '督学师',
  placeholderSelectSupervisor: '请选择督学师',
  monthLabel: '月份',
  monthNumberLabel: '{n}月',
  totalErrorNumCol: '累计异常数',
  levelThreeCol: '三级',
  levelTwoCol: '二级',
  levelOneCol: '一级',
  viewStudentsCol: '查看学生',
  writeNumCol: '小结填写次数',
  summaryCoverRateWeek1Col: '督学小结覆盖率1周',
  summaryCoverRateWeek2Col: '督学小结覆盖率2周',
  summaryCoverRateWeek3Col: '督学小结覆盖率3周',
  summaryCoverRateWeek4Col: '督学小结覆盖率4周',
  summaryCoverRateWeek5Col: '督学小结覆盖率5周',
  summaryCoverTip: '督学小结覆盖率：每周单科学习时长≥50分钟的学生，填写了督学小结的人科数占比',
  newPeopleStudentNameCol: '新手姓名',
  newStudentNameOrPhoneLabel: '新手姓名或者手机号',
  placeholderInput: '请输入',
  newStudentPeriodCol: '新生周期',
  newPeopleStudentNameCol: '新生姓名',
  supervisorInChargeCol: '负责督学师',
  totalStudyTimeCol: '总学习时长',
  draftConditionCol: '草稿书写情况',
  independentProcessCol: '自主流程讲解',
  firstWeekFeedbackCol: '首周反馈',
  instinctLevelCol: '本能级讲解',
  healthLevelCol: '健康升降级讲解',
  recentThreeScoresCol: '最近三次成绩',
  yearMonthCol: '月份',
  totalScoreCol: '总得分',
  studyTimeScoreCol: '学习时长',
  activeScoreCol: '高度活跃',
  studyErrorScoreCol: '学习过程异常',
  studyMarkScoreCol: '学习留痕分',
  threeMonthWeightScoreCol: '三月服务留存率',
  honorNameCol: '全流程培训',
  mathDdjDurationCol: '数学打基础累计时长',
  mathDdjMaxProgressCol: '数学打基础最高进度',
  chineseDdjDurationCol: '语文打基础累计时长',
  chineseDdjMaxProgressCol: '语文打基础最高进度',
  englishDdjDurationCol: '英语打基础累计时长',
  englishDdjMaxProgressCol: '英语打基础最高进度',
  difficultyLevelCol: '难度等级表讲解能力',
  healthLevelAbilityCol: '健康度升降级讲解能力',
  supervisorStudentsTitle: '督学的学生',
  supervisorSummaryLabel: '督学小结',
  notFilled: '未填写',
  notVisitSupervisor: '未到店督学',
  getDataFailed: '获取数据失败',

  // accountEditRecord 账号修改记录
  opDesc: '操作描述',
  opType: '操作类型',
  opTime: '操作时间',

  // SupervisorSummary 督学小结
  back: '返回',
  supervisorSummary: '督学小结',
  studyTime: '学习时长',
  effectiveTime: '有效时长',
  dataUpdateTo: '数据更新至：',
  dataUpdateTooltip: '每日更新前一天数据，每周一固定上周数据',
  studyExceptionOverview: '学习异常概览',
  levelException: '级异常：',
  noExceptionThisWeek: '本周没有异常情况哦！',
  studyMonitorAlarm: '学习过程监课报警',
  studyExceptionHelp: '学生学习过程出现异常怎么办？',
  weekAlarmCount: '本周累计报警数：',
  highestRatio: '的占比最高：',
  dateCol: '日期',
  studyTimeCol: '学习时长',
  daze: '发呆',
  times: '次数',
  durationMin: '时长(分)',
  leaveMidway: '中途离开',
  consecutiveWrong: '连错',
  totalWrongCount: '总错题数',
  answerSlowly: '答题过慢',
  questionCount: '题目数',
  wrongCount: '错题数',
  answerFast: '答题过快',
  skipVideo: '跳视频',
  quantity: '数量',
  afterAnswerWrong: '后续答题错误',

  // SupervisorSummary 例题试做/草稿/读题圈画/错因分析
  exampleTrialTitle: '例题试做情况',
  exampleTrialNorm: '例题试做规范性',
  weekExampleTrialRate: '本周例题试做率：',
  videoStillWrongTip: '个视频的试做看了仍然不会，请关注',
  videoStillWrongPrefix: '，有',
  hasCount: '，有',
  viewTrialErrorKnowledge: '查看试做错误的知识点',
  viewDetail: '查看明细',
  draftWritingTitle: '草稿步骤书写情况',
  draftWritingQualifyHelp: '如何判断草稿书写是否合格？',
  draftSampleRate: '抽查草稿步骤合格率：',
  readCircleTitle: '读题圈画情况',
  readCircleHelp: '如何做好读题圈画？',
  completionStatus: '完成情况：',
  errorAnalysisTitle: '错因分析',
  errorAnalysisHelp: '错因分析如何做？',
  errorAnalysisRequireTip: '当孩子在做1-6级（前两次）打基础时，必须要做错因分析',
  weekErrorAnalysisRate: '本周1-6级错因分析完成率：',
  trialErrorRightLabel: '试做错误看了视频会了',
  trialErrorWrongLabel: '试做错误看了视频不会',
  draftWritingRateLabel: '草稿步骤书写率',
  draftPassRateLabel: '草稿步骤合格率',
  draftRightRateLabel: '书写草稿题目的正确率',
  noDraftRightRateLabel: '未书写草稿题目的正确率',
  totalRightRateLabel: '整体正确率',

  readCircleCount: '圈画的题目数',
  readCircleRate: '覆盖率',
  readCircleRightRate: '圈画题目正确率',
  noReadCircleRightRate: '未圈画题目正确率',
  invalidReadCircleCount: '无效圈画题目数',
  validReadCircleRate: '有效圈画率',

  courseLevelNumLabel: '课程级数/次数',
  errorAnalysisStatusLabel: '错因分析完成情况',
  errorAnalysisRequireLabel: '错因要求',
  learnErrorCount: '学习错题数',
  markedErrorCount: '已标记的错题数',
  errorMarkRate: '错因标记率',
  uploadedImagesLabel: '上传的图片',
  levelLabel: '级',
  batchLabel: '第',
  batchSuffix: '次',
  weekTotal: '周合计',
  trialErrorKnowledgeDialogTitle: '试做错误的知识点',
  trialDateLabel: '试做日期: ',
  tryResultLabel: '试错结果',
  wrongButGotIt: '错误，会了',
  wrongStillNot: '错误，还是不会',
  learnRightRateLabel: '学习正确率',
  exceptionScenarioDialogTitle: '学习异常场景说明',
  alarmDialogTitle: '学习过程监课报警说明',
  countDescLabel: '次数说明：',
  totalVideoCount: '总视频数',
  exampleTrialCount: '例题试做数',
  trialRightLabel: '试做正确',
  totalQuestionCount: '总题目数',
  draftWritingCount: '草稿步骤书写数',
  courseLabel: '课程',
  chapterTaskLabel: '章/任务卡',
  knowledgeLabel: '知识点',
  errorTypeLabel: '错误类别',
  questionCountLabel: '题目数',
  ratioLabel: '占比',
  examProblemLabel: '审题问题',
  calcErrorLabel: '计算错误',
  notKnowLabel: '该题不会',
  systemErrorLabel: '系统识别错误',
  otherLabel: '其他',
  exampleTrialRate: '例题试做率',
  exceptionLevelLabel: '异常级别',
  severityLabel: '严重程度',
  exceptionScenarioLabel: '一级异常场景',
  triggerConditionLabel: '触发条件',
  alarmSituationLabel: '报警情况',

  // ScoreRuleDialog 评分规则说明
  scoreRuleTitle: '评分如何计算？',
  scoreRuleIntro: '总分（满分10分）由以下5个维度的表现共同决定。',
  scoreRuleGotIt: '我知道了',
  scoreRuleDimension: '维度',
  scoreRuleTotalScore: '总分',
  scoreRuleWeight: '权重',
  scoreRuleStudyTime: '学习时长',
  scoreRuleHighActive: '高度活跃',
  scoreRuleStudyError: '学习过程异常',
  scoreRuleStudyMark: '学习留痕分',
  scoreRule3MonthRetention: '3月服务留存率',
  scoreRule10Points: '10分',
  scoreRuleWeight25: '25%',
  scoreRuleWeight25New: '25%(新人) / 25%(非新人)',
  scoreRuleWeight0New: '0%(新人) / 10%(非新人)',
  scoreRuleBasis: '评分依据：',
  scoreRuleStudyTimeDesc1: '根据督学师督学的学生们每周的时长分平均值计算。',
  scoreRuleStudyTimeDesc2: '学生的周时长分：周最长学习学科的时长为T',
  scoreRuleStudyTimeDesc3: '春秋：T ÷ 6 × 10，最大为10分',
  scoreRuleStudyTimeDesc4: '寒暑：T ÷ 20 × 10，最大为10分',
  scoreRuleStudyTimeDesc5: '每月得分 = 当月所有周得分的平均分。',
  scoreRuleHighActiveDesc1: '根据督学学生高度活跃占比',
  scoreRuleHighActiveDesc2: '以全国平均为基准，占比每高出10%就加1分，每低10%就减1分',
  scoreRuleHighActiveDesc3: '每月得分 = 当月所有周得分的平均分',
  scoreRuleStudyErrorDesc1: '根据督学学生学习过程异常情况',
  scoreRuleStudyErrorDesc2: '每个学生每周有10分基础分，出现异常会被扣分',
  scoreRuleStudyErrorDesc3: '异常等级不同扣分不同，春秋寒暑的扣分标准有区别',
  scoreRuleStudyErrorDesc4: '当周的得分是督学学生得分的平均分',
  scoreRuleStudyErrorDesc5: '每月得分 = 当月所有周得分的平均分',
  scoreRuleStudyMarkDesc1: '督学过程中各项留痕率的情况。',
  scoreRuleStudyMarkDesc2: '根据督学过程的几个留痕率对应不同的分数来计算得分',
  scoreRule3MonthDesc1: '督学结果3月服务留存率的情况。',
  scoreRule3MonthDesc2: '得分 = 督学结果的3月服务留存率 ÷ 0.6 × 10',
  scoreRule3MonthNote: '注意：新人督学师（3个月内）此项不计算',

  // ImproveScores 提分率
  supervisorTeacherLabel: '督学师：',
  placeholderSelectSupervisorTeacher: '请选择督学师',
  yearLabelWithColon: '年份：',
  termLabel: '学期：',
  examTypeLabel: '大考类型：',
  improveScoresSubjectLabel: '学科',
  supervisorTeacherNameCol: '督学师姓名',
  schoolYearCol: '年份',
  termCol: '学期',
  examTypeCol: '考试类型',
  scoreCollectRateCol: '成绩收集率',
  validScoreRateCol: '有效成绩率',
  scoreImproveRateCol: '提分率',
  studyRoomStudentNumCol: '自习室学员数',
  onlineOnlyStudentNumCol: '仅线上学员数',
  submitScoreStudentNumCol: '提交成绩学员数',
  validScoreStudentNumCol: '有效成绩学员数',
  improveStudentNumCol: '提分学生数',
  submitTwiceStudentNumCol: '提交两次成绩学生数',
  noScoreStudentNumCol: '收集不到成绩学生数',
  dataUpdateTimeLabel: '数据更新时间：',
  foldText: '收起',
  expandText: '展开',
  clearFilterText: '清除筛选',

  // SupervisorEvaluationScore 督学师评价分
  evaluationScoreMonthDealerLabel: '经销商',
  monthDataTab: '月数据',
  weekDataTab: '周数据',
  placeholderSelectYear: '请选择年份',
  weekEndDateCol: '周（截止日期）',
  highActiveScoreCol: '高度活跃分',
  threeMonthRetentionScoreCol: '三个月服务留存率分',

  // 阶段年级 stageGrade
  preschoolStage: '学前',
  primarySchoolStage: '小学',
  juniorHighStage: '初中',
  seniorHighStage: '高中',
  otherStage: '其他',
  smallClass: '小班',
  middleClass: '中班',
  bigClass: '大班',
  grade1: '一年级',
  grade2: '二年级',
  grade3: '三年级',
  grade4: '四年级',
  grade5: '五年级',
  grade6: '六年级',
  grade7: '七年级',
  grade8: '八年级',
  grade9: '九年级',
  grade10: '高一',
  grade11: '高二',
  grade12: '高三',
  generalGrade: '通用',

  // 学期 term
  firstTerm: '上学期',
  secondTerm: '下学期',
  autumnTerm: '秋季',
  springTerm: '春季',

  // 学科 subject
  englishSubject: '英语',
  mathSubject: '数学',
  chineseSubject: '语文',
  physicsSubject: '物理',
  chemistrySubject: '化学',
  biologySubject: '生物',
  geographySubject: '地理',
  scienceSubject: '科学',

  // 任务步骤状态 TaskStepStatus
  unlocked: '未解锁',
  inProgress: '进行中',
  completed: '已完成',

  // 门店状态 agentStoreStatus
  openingPending: '开业待确认',
  opened: '已开业',
  openingRejected: '开业已驳回',
  siteSelectionPending: '选址待确认',
  siteSelectionRejected: '选址已驳回',
  pendingOpening: '待开业',
  openingCanceled: '取消开业',
  temporaryClosed: '临时停业',
  permanentlyClosed: '永久停业',
  preSitePending: '预选址待确认',
  preSiteRejected: '预选址已驳回',
  preSite: '预选址',
  siteSelectionCanceled: '取消选址',
  preSiteWithdrawn: '预选址已撤回',
  siteSelectionWithdrawn: '选址已撤回',
  closurePending: '停业待审核',
  reopenPending: '恢复营业待审核',
  storeInStorePending: '店中店待审核',
  storeInStoreRejected: '店中店已驳回',
  storeInStoreCanceled: '取消店中店报备',

  // supervisorGrowth 督学师成长
  mathDdjDurationCol: '数学打基础，累计时长',
  mathDdjMaxProgressCol: '数学打基础，最高进度',
  chineseDdjDurationCol: '语文打基础，累计时长',
  chineseDdjMaxProgressCol: '语文打基础，最高进度',
  englishDdjDurationCol: '英语打基础，累计时长',
  englishDdjMaxProgressCol: '英语打基础，最高进度',
  difficultyLevelCol: '难度等级表讲解能力',
  healthLevelAbilityCol: '健康度升降级讲解能力',
  hoursUnit: '小时',
  levelUnit: '级',
  noRecording: '未传录音',
  scoreLabel: '成绩：',
  scoreUnit: '分',
  pendingProvincialScore: '待省平台评分中',
  selfEvalLabel: '自评：',
  listenRecording: '听录音',
  playRecording: '播放录音',
  supervisorsNoData: '等位督学师暂无数据',
  supervisorsNoDataWarn: '{names}等{count}位督学师暂无数据',

  // newPeople 新人督学
  viewImage: '查看图片',
  notCompleted: '未完成',
  completed: '已完成',
  questionMarkCol: '读题圈画情况',
  knowledgePointCol: '知识点笔记',
  audioParseError: '音频解析出错，请重新上传',
  allOption: '全部',
};
